module.exports = __webpack_public_path__ + "img/BNHCRC-Rel1-GREY-Rev.324ad8ab.png";